import { Nillable } from "../base/@types";

export type HasTimestamps = ReturnType<typeof hasTimestamps>;

export const hasTimestamps = () => ({
  timeCreated: '' as Nillable<string>,
  timeUpdated: '' as Nillable<string>,
  timeDeleted: '' as Nillable<string>,
})
